<template>
  <section
    id="become-ganga7s-partner"
    class="section-become-ganga7s-partner section-content"
  >
    <!-- 漸層背景 -->
    <div
      :class="[
        'gradient-background',
        { 'fill-background': isEnteringSectionBecomeGanga7Partner },
      ]"
    ></div>

    <!-- 圖片背景 -->
    <div
      :class="[
        'man-image-background',
        { 'fade-in': isEnteringSectionBecomeGanga7Partner },
      ]"
    >
      <img
        src="~@/assets/images/section-become-ganga7s-partner/big-money.png"
        alt="JOIN GANGA7 TO FULFILL YOUR DREAM."
      />
    </div>

    <div
      :class="[
        'content-text c-fff',
        { 'fade-in': isEnteringSectionBecomeGanga7Partner },
      ]"
    >
      <div class="content-text__title fz-40 fw-700 fz-mbl-30 fz-mbp-24">
        <p>Join</p>
        <img
          src="~@/assets/images/button-text-ganga7.png"
          class="content-text__title--logo"
        />
        <p>to Make Money</p>
      </div>
      <p class="fz-20 fz-mbl-18 fw-700">Become GANGA7's Partner.</p>
      <p class="fz-15 fw-600">
        Keen to find out more? Feel free to contact us.
      </p>
    </div>

    <div
      :class="[
        'contact-buttons',
        { 'fade-in': isEnteringSectionBecomeGanga7Partner },
      ]"
    >
      <a
        v-if="contactLinkSetting.whatsApp"
        :href="contactLinkSetting.whatsApp.link"
        class="contact-button contact-button--whatsApp c-fff"
        :title="contactLinkSetting.whatsApp.title"
        target="_blank"
        :style="{
          'pointer-events': contactLinkSetting.whatsApp.link
            ? 'initial'
            : 'none',
        }"
      >
        <img
          class="contact-button__icon"
          src="~@/assets/images/section-become-ganga7s-partner/whats-app.svg"
        />
        <p class="text fz-20-vw fz-mbl-18">WhatsApp</p>
      </a>
      <a
        v-if="contactLinkSetting.telegram"
        :href="contactLinkSetting.telegram.link"
        class="contact-button contact-button--telegram c-fff"
        :title="contactLinkSetting.telegram.title"
        target="_blank"
        :style="{
          'pointer-events': contactLinkSetting.telegram.link
            ? 'initial'
            : 'none',
        }"
      >
        <img
          class="contact-button__icon contact-button__icon--telegram"
          src="~@/assets/images/section-become-ganga7s-partner/telegram.svg"
        />
        <p class="text fz-20-vw fz-mbl-18">Telegram</p>
      </a>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    isEnteringSectionBecomeGanga7Partner: {
      type: Boolean,
    },
    contactLinkSetting: {
      type: Object,
    },
  },

  data() {
    return {};
  },
};
</script>

<style lang="scss">
.section-become-ganga7s-partner {
  @include mq(max-600) {
    padding: 60% 0 20px;
  }

  position: relative;

  height: auto;

  padding: 30% 0 40px;

  .gradient-background {
    @include mq(max-600) {
      height: 80%;
    }

    position: absolute;
    bottom: 0;
    height: 85%;
    width: 100%;

    background-image: linear-gradient(
      180deg,
      #ebca65 0%,
      #f7d973 50%,
      #ac6d00 100%
    );

    opacity: 0;
    transform-origin: center bottom;
    transform: scaleY(0);

    transition: all 0.8s 0.65s;

    &.fill-background {
      opacity: 1;
      transform: scaleY(1);
    }

    &::before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;

      background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.7) 15%,
        rgba(0, 0, 0, 0) 70%
      );

      content: "";
    }
  }

  .man-image-background {
    position: absolute;
    left: 50%;
    bottom: 0;
    height: 100%;
    opacity: 0;
    transform: translate(-50%, 100px);
    display: flex;
    align-items: flex-end;

    transition: all 0.65s;

    &.fade-in {
      opacity: 1;
      transform: translate(-50%, 0);
    }

    img {
      @include mq(max-600) {
        height: 90%;
      }

      height: 100%;
    }
  }

  .content-text {
    @include mq(max-600) {
      position: static;
    }

    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;

    text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.6);

    opacity: 0;

    transition: all 0.6s 1.2s;

    &.fade-in {
      opacity: 1;
    }

    &__title {
      @include mq(max-600) {
        position: absolute;
        top: 0;
        flex-wrap: wrap;

        padding: 0 10px;
      }

      display: flex;
      justify-content: center;
      align-items: center;

      &--logo {
        @include mq(mbl) {
          height: 30px;
        }

        margin: 0 10px;
        height: 48px;
      }
    }
  }

  .contact-buttons {
    display: flex;

    justify-content: center;

    margin-top: 22px;

    opacity: 0;

    transition: all 1s 1.5s;

    &.fade-in {
      opacity: 1;
    }

    .contact-button {
      @include mq(mbl) {
        height: 40px;
        padding: 0 14px;
        margin: 0 10px;
      }

      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid #fff;
      border-radius: 68px;
      background-image: var(--gradient-2);
      padding: 0 26px;
      height: 54px;
      text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.6);

      transition: all 0.3s;

      margin: 0 20px;

      &:hover {
        transform: scale(1.1);
      }

      &__icon {
        filter: brightness(100%);

        height: 30px;

        margin-right: 10px;
      }
    }
  }
}
</style>
